module.exports = __webpack_public_path__ + "img/embaixo2.5a21782e.jpg";